import { Chip, FormControlLabel, Radio, Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React, { memo } from 'react';
import Colors from '../../../utils/color';
import { IModChoiceStyleProps } from './MultipleModChoice';

const useStyles = makeStyles<IModChoiceStyleProps>()(
  ({ spacing }, { is86edToday }) => {
    const chipColor = is86edToday ? Colors.red : '';
    const chipTextDecoration = is86edToday ? 'line-through' : '';
    return {
      button: {
        display: 'none !important',
      },
      chipContainer: {
        borderRadius: `${spacing(0.5)} !important`,
        fontWeight: 'bold !important',
        textTransform: 'uppercase',
        height: `${spacing(5)} !important`,
        width: '100%',
        '& .MuiChip-label': {
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          whiteSpace: 'normal',
          textAlign: 'center',
          lineHeight: '1.2',
        },
      },
      controlLabel: {
        width: '18%',
        margin: `0px ${spacing(1.125)} ${spacing(1.25)} 0px !important`,
        height: `${spacing(5)}`,
        display: 'inline-block !important',
        '& .MuiFormControlLabel-label': {
          display: 'inline-block !important',
          width: '100%',
        },
        '& .MuiChip-root.MuiChip-filled': {
          backgroundColor: Colors.mineShaft,
          color: Colors.white,
        },
        '& .MuiChip-root': {
          cursor: 'pointer',
          fontSize: spacing(1.25),
          color: chipColor,
          textDecoration: chipTextDecoration,
        },
      },
    };
  }
);

interface ISingularModChoice {
  id: string;
  name: string;
  modLabel: string;
  is86edToday: boolean;
  isSelected: boolean;
}

const SingularModChoice = ({
  id,
  name,
  modLabel,
  is86edToday,
  isSelected,
}: ISingularModChoice) => {
  const { classes } = useStyles({ is86edToday });

  const ctrl = <Radio color="primary" className={classes.button} />;

  const label = (
    <Chip
      label={modLabel}
      title={name}
      variant={isSelected ? 'filled' : 'outlined'}
      className={classes.chipContainer}
    />
  );
  return (
    <FormControlLabel
      value={id}
      control={ctrl}
      label={label}
      className={classes.controlLabel}
    />
  );
};

export default memo(SingularModChoice);
